<template lang="html">

  <section class="ussd">
    <div class="content">
        <div class="section " id="homeussd">
            <div class="container">
                <div class="headtitle">
                    <div class="text-center">
                        <h1>Applications USSD</h1>
                    </div>
                </div>
            </div>
        </div>

        <h4 class="bodytitle text-center">Vous pouvez désormais acheter vos billets sans connexion Internet</h4>

        <div class="section" id="ussdcode">
            <div class="container">

                <div class="row justify-content-md-center infobloc shadow-sm">
                    <div class="col-md-2">
                        <img src="../assets/img/om.png" class="logoM">
                    </div>
                    <div class="col-md-4 text-center">
                        <h5>Orange CI</h5>
                        <p>#144*4821#</p>
                    </div>

                </div>
                
                <div class="row justify-content-md-center infobloc shadow-sm">
                    <div class="col-md-2">
                        <img src="../assets/img/mtn_logo.png" class="logoM">
                    </div>
                    <div class="col-md-4 text-center">
                        <h5>MTN CI</h5>
                        <p>*133*135#</p>
                    </div>

                </div>
                
            </div>

        </div>

        <pied-creer-billetterie/>

    </div>
  </section>

</template>

<script lang="js">
  import PiedCreerBilletterie from '@/components/PiedCreerBilletterie.vue'
  export default  {
    name: 'ussd',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    },
    components:{
      PiedCreerBilletterie
    }
}
</script>

<style scoped>
  .section#homeussd
  {
      background-image: url(../assets/img/hand_phone.png);
      position: relative;
      overflow-y: hidden;
      background-size: 30% auto;
      background-repeat: no-repeat;
      background-position: center bottom ;
      background-blend-mode: multiply;
      background-color: #32517F;
      margin-bottom: 5em;
      padding: 10em 0;
  }

  .section#homeussd .headtitle h1
  {
      color: #ffffff;
  }

  .section#ussdcode .logoM
  {
      width: 100%

  }

  .section#ussdcode .container p
  {
      color: #32517F;
      font-size: 4em;
  }

  .section#ussdcode .container h5
  {
      font-size: 2em;
  }

  .section#ussdcode  .infobloc
  {
      background-color: #FDFDFD;
      border-radius: 1em;
      padding: 3em;
  }
</style>
